// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    PRODUCTION: false,
    BASE_URL:'https://qa-ezlocator-admin-apis.azurewebsites.net',
    CLIENT_ID: "admin-ui",
    IDP_URL: 'https://qaezlocatorapis.azurewebsites.net',
    V5_URL: "https://qa.ezlocator.com",
    ACTIVE_TIME_DOMAIN: "ezlocator.com",
    LIDAR_BASE_URL: "https://qa-lidar-processor-apis.azurewebsites.net",
    NOINDEX: true
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  